export default __webpack_public_path__ + "static/plan-3-meal-rollover-85cd5381ad9404ed0dc2c3d80f3f5d84.jpg";